module.exports = __webpack_public_path__ + "static/img/PayPalLogo.fcdb242.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/PayPalLogo.png
// module id = wfNo
// module chunks = 1